<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.create.action`)"
    :toasts="toasts"
    :resource="model"
  >
    <template #top>
      <resource-action-header :model="model" :action="'create'"></resource-action-header>
    </template>
    <Box v-if="model.data">
      <resource-form :errors="errors" :resource="model"></resource-form>
    </Box>
    <template #right>
      <admin-sidebox :resource="model"></admin-sidebox>
    </template>
  </Layout>
</template>

<script>
import ResourceForm from '@kanrisha/components/ResourceForm';
import Layout from '@kanrisha/Pages/Layout';
import useResource from '@kanrisha/composables/useResource';
import ResourceActionHeader from '@kanrisha/components/Layout/ResourceActionHeader';
import Box from '@kanrisha/components/Base/Box';
import AdminSidebox from '@kanrisha/components/Layout/AdminSidebox';

export default {
  components: {
    AdminSidebox,
    Box,
    ResourceActionHeader,
    Layout,
    ResourceForm,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  setup(props) {
    const { resourceType } = useResource(props, props.model);

    return {
      resourceType,
    };
  },
};
</script>
